import { SwrPaginationInterface } from 'shared/types/swr-pagination-interface'

export interface GetPaginationQueryStringProps extends SwrPaginationInterface {}

export const getPaginationQueryString = ({ limit, pagination }: GetPaginationQueryStringProps) =>
  limit &&
  (pagination.startFromId
    ? `pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    : `pagination[limit]=${limit}`)
